// eslint-disable-next-line import/prefer-default-export
export const INFRASTRUKTURBAU_SUBSTATI = 'infrastrukturbau_substati';

export const INFRASTRUKTUR_GRUPPEN_FLAT = 'infrastruktur_gruppen_flat';
export const INFRASTRUKTUR_STANDORTE_FLAT = 'infrastruktur_standorte_flat';
